import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { applySsoSession } from "@/services/auth";
import { AequiaMark } from "@/components/ui";

/**
 * Aterrizaje del callback SSO/AD (Sprint 60). El backend redirige aquí con los
 * tokens en el fragmento (#accessToken=…&refreshToken=…&expiresIn=…). Establece
 * la sesión y recarga hacia el destino para que el AuthContext arranque autenticado.
 */
export default function SsoCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const hash = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(hash);
    const accessToken = params.get("accessToken");
    const refreshToken = params.get("refreshToken");
    const expiresIn = Number(params.get("expiresIn") ?? "0");
    if (!accessToken || !refreshToken) {
      setError("No se recibieron credenciales del proveedor.");
      return;
    }
    const user = applySsoSession(accessToken, refreshToken, expiresIn || 3600);
    // Limpia el fragmento con los tokens antes de continuar.
    window.history.replaceState(null, "", window.location.pathname);
    if (!user) {
      setError("No se pudo establecer la sesión.");
      return;
    }
    // Recarga completa para reinicializar el AuthContext desde el almacenamiento.
    window.location.replace(
      user.mustChangePassword ? "/force-change-password" : "/dashboard",
    );
  }, [navigate]);

  return (
    <div className="paper min-h-screen grid place-items-center p-8">
      <div className="text-center">
        <AequiaMark size={84} />
        <p className="mt-6 text-sm text-muted">
          {error ?? "Estableciendo tu sesión…"}
        </p>
        {error && (
          <button
            type="button"
            onClick={() => navigate("/login", { replace: true })}
            className="mt-3 text-sm text-primary hover:underline"
          >
            Volver al inicio de sesión
          </button>
        )}
      </div>
    </div>
  );
}
